export default __webpack_public_path__ + "static/media/dashboard.8a5938de.png";